"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeUserEg = exports.createPageEventObject = exports.extractMainProperties = exports.extractUserProperties = exports.extractComponentTagging = void 0;
const extractComponentTagging = (contextObj) => {
    let res = {
        'event_type': contextObj['event_type'],
        'component_name': contextObj['component_name'],
        'component_content': contextObj['component_content'],
        'component_product': contextObj['component_product'],
        'component_perso': JSON.stringify(contextObj['component_perso']),
        'component_variation': contextObj['component_variation'],
    };
    return res;
};
exports.extractComponentTagging = extractComponentTagging;
const extractUserProperties = (contextObj, shouldSendHash, userIdPartyHashFromGetEg) => {
    let res = {
        'context_ga_cookie': shouldSendHash ? contextObj['context-ga-cookie'] : '', // muerte sin cookie
        'user_client': contextObj['user-client'],
        'user_consent_cookie_onetrust': contextObj['user-consent-cookie-onetrust'],
        'user_cuc_fijo_hash': shouldSendHash ? contextObj['user-cuc-fijo-hash'] : '', // muerte sin cookie
        'user_cuc_movil_hash': shouldSendHash ? contextObj['user-cuc-movil-hash'] : '', // muerte sin cookie
        'user_cuc_prepago_hash': shouldSendHash ? contextObj['user-cuc-prepago-hash'] : '', // muerte sin cookie
        'user_id_party_hash': shouldSendHash ? contextObj['user-id-party-hash'] || userIdPartyHashFromGetEg : '', // muerte sin cookie
        'user_ip_hash': shouldSendHash ? contextObj['user-ip-hash'] : '', // muerte sin cookie
        'user_operador_hash': shouldSendHash ? contextObj['user-operador-hash'] : '', // muerte sin cookie
        'user_priority': contextObj['user-priority'],
        'user_telefono_fijo_hash': shouldSendHash ? contextObj['user-telefono-fijo-hash'] : '', // muerte sin cookie
        'user_telefono_movil_hash': shouldSendHash ? contextObj['user-telefono-movil-hash'] : '', // muerte sin cookie
        'user_type': contextObj['user-type'],
    };
    return res;
};
exports.extractUserProperties = extractUserProperties;
const extractMainProperties = (contextObj, isWebviewBool = false, isColAppBool = false) => {
    let page_name = contextObj['page-name'];
    if (!page_name) {
        let tokens = window.location.pathname.split('/').filter(item => !!item);
        page_name = tokens.join(':');
    }
    if (isWebviewBool) {
        page_name = `webview:${page_name}`;
    }
    if (isColAppBool) {
        page_name = `colapp:${page_name}`;
    }
    let res = {
        page_name,
        'page_product_code': contextObj['page-product-code'],
        'page_product_name': contextObj['page-product-name'],
        'page_segment': contextObj['page-segment'],
        'context_page_id': contextObj['context-page-id'],
        'context_seo_meta': contextObj['context-seo-meta'],
        'context_session_id': contextObj['context-session-id'],
        'context_tab_id': contextObj['context-tab-id'],
        'context_url': contextObj['context-url'],
    };
    return res;
};
exports.extractMainProperties = extractMainProperties;
const createPageEventObject = (data) => {
    if (!data) {
        return null;
    }
    const { clientIDs, userType: userTypeFromData } = data;
    const { event = 'cms-page', eventType = '', tabId = '', pageName = '', pageProductCode = '', pageProductName = '', contextGaCookie = (clientIDs && clientIDs.ga) || null, contextSessionId = (clientIDs && clientIDs.sessId) || null, contextPageId = (clientIDs && clientIDs.pageId) || null, userCUCFijoHash = '', userCUCMovilHash = '', userCUCPrepagoHash = '', userIPHash = '', userOperadorHash = '', userTelefonoFijoHash = '', userTelefonoMovilHash = '', userIdPartyHash = '', userType = '', pageSegment = '', contextURL = '', userClient = !!userTypeFromData, contextSeoMeta = '', } = data;
    return {
        event,
        'event-type': eventType,
        'context-tab-id': tabId,
        'page-name': pageName,
        'page-product-code': pageProductCode,
        'page-product-name': pageProductName,
        // client id de ga
        'context-ga-cookie': contextGaCookie,
        // id de sesión de la navegación del usuario
        'context-session-id': contextSessionId,
        // page id de la página
        'context-page-id': contextPageId,
        'user-cuc-fijo-hash': userCUCFijoHash,
        'user-cuc-movil-hash': userCUCMovilHash,
        'user-cuc-prepago-hash': userCUCPrepagoHash,
        'user-ip-hash': userIPHash,
        'user-operador-hash': userOperadorHash,
        'user-telefono-fijo-hash': userTelefonoFijoHash,
        'user-telefono-movil-hash': userTelefonoMovilHash,
        'user-id-party-hash': userIdPartyHash,
        // telco o legado
        'user-type': userType,
        // segmento de navegación de la página
        'page-segment': pageSegment,
        // url de la página
        'context-url': contextURL,
        // true o false si es cliente o no
        'user-client': userClient,
        // meta description de seo
        'context-seo-meta': contextSeoMeta,
    };
};
exports.createPageEventObject = createPageEventObject;
const normalizeUserEg = (contextObj) => {
    let res = {};
    if (contextObj) {
        res = {
            'user_cuc_fijo_hash': contextObj.userCUCFijoHash || "",
            'user_cuc_movil_hash': contextObj.userCUCMovilHash || "",
            'user_cuc_prepago_hash': contextObj.userCUCPrepagoHash || "",
            'user_id_party_hash': contextObj.userIdPartyHash || contextObj.userIdPartyHashFromGetEg || "",
            'user_ip_hash': contextObj.a || "",
            'user_operador_hash': contextObj.x || "",
            'user_telefono_fijo_hash': contextObj.t || "",
            'user_telefono_movil_hash': contextObj.g || "",
        };
    }
    return res;
};
exports.normalizeUserEg = normalizeUserEg;
//# sourceMappingURL=utils.js.map